<template>
  <div class="shop-info-container">
    <!-- 面包屑导航 - 美化 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="custom-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店信息</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主卡片 -->
    <el-card class="modern-card" shadow="never">
      <!-- 基本信息描述列表 - 支付宝风格 -->
      <div class="info-section">
        <div class="section-header">
          <span class="section-title">基本信息</span>
          <span class="section-line"></span>
        </div>
        <el-descriptions :column="3" border class="alipay-descriptions">
          <el-descriptions-item label="名称：" label-class-name="desc-label" content-class-name="desc-content">
            {{ addForm.name || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="性别：">
            {{ addForm.sex == 1 ? '男' : (addForm.sex == 0 ? '女' : '--') }}
          </el-descriptions-item>
          <el-descriptions-item label="身份证：">
            {{ addForm.id_code || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="联系电话：">
            <el-tag size="small" effect="light" type="success">{{ addForm.mobile || '--' }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="编码：">
            {{ addForm.sn || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="社保状况：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
          <el-descriptions-item label="是否在建：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
          <el-descriptions-item label="执业时间：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
          <el-descriptions-item label="社保开始缴纳时间：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
          <el-descriptions-item label="费用缴纳单位：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
          <el-descriptions-item label="在公司注册成功时间：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
          <el-descriptions-item label="转出时间：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
          <el-descriptions-item label="创建人：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间：">
            <span class="empty-placeholder">--</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 证书信息表格 -->
      <div class="info-section" style="margin-top: 32px">
        <div class="section-header">
          <span class="section-title">证书信息</span>
          <span class="section-line"></span>
        </div>
        <el-table
          :data="creditList"
          border
          style="width: 100%"
          class="alipay-table"
          :header-cell-style="headerCellStyle"
          v-if="creditList.length > 0"
        >
          <el-table-column prop="date" label="序号" width="70" align="center"></el-table-column>
          <el-table-column prop="date" label="证书名称" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="证书编号" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="address" label="证书注册号" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="address" label="证书专业" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="address" label="取得时间" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="address" label="到期时间" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="address" label="证书预览" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="previewCertificate(scope.row)">预览</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="证书下载" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="downloadCertificate(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-empty v-else description="暂无证书信息" :image-size="100" class="custom-empty"></el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  components: {},
  data() {
    return {
      employeeList: [],
      performanceList: [],
      creditList: [], // 证书列表数据，实际使用时替换为真实数据
      tableData: [
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }
      ],
      list: [
        {
          sku_name: '',
          sn: '',
          id: null,
          product_id: '',
          product_name: '',
          brandSort: null,
          type: null,
          unit_name: null,
          num: null,
          isEgdit: true,
          brand_name: '',
          brand_id: ''
        }
      ],
      baseUrl: '/api/',
      fileList: [],
      shopList: [],
      dicList: [],
      cateList: [],
      provinceList: [],
      access_token: sessionStorage.getItem('token'),
      company_id: sessionStorage.getItem('company_id'),
      addForm: {
        handed_other_name: '',
        handed_id: '',
        address: '',
        total_amount: '',
        payee_account: '',
        payee_name: '',
        credit_code: '',
        employee_id: '',
        type_id: '',
        cate_id: '',
        province_id: "",
        dic_id: '',
        amount: '',
        remark: '',
        order_time: '',
        summary: "",
        manager_name: '',
        unit_name: "",
        title: '',
        shop_id: '',
        // 基本信息字段
        name: '',
        sex: null,
        id_code: '',
        mobile: '',
        sn: ''
      },
      ruleForm: {
        url: '',
        start_time: "",
        ad_id: '',
        ad_name: '',
        ad_link: '',
        position_id: '',
        ad_code: ''
      },
      cateMenus: [],
      editor: null,
      html: '<p>hello</p>',
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      mode: 'default',
      rules: {
        title: [{ required: true, message: "请输入合同名称", trigger: 'change' }],
        position_id: [{ required: true, message: "请选择分类", trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.getCateMenus()
    var id = this.$route.query.id
    if (!isNaN(id) && id > 0) {
      this.addForm.id = id
      this.getOne()
    }
    this.getDicList()
    this.getCateList()
    this.getProvinceList()
    this.getShopList()
    this.getEmployeeList()
    // 模拟证书数据（实际应从接口获取）
    this.creditList = []
  },
  methods: {
    // 表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#F8F9FC',
        color: '#1E2A3A',
        fontWeight: 600,
        fontSize: '14px',
        borderBottom: '1px solid #EDEFF2'
      }
    },
    // 预览证书
    previewCertificate(row) {
      if (row.cert_url) {
        window.open(row.cert_url, '_blank')
      } else {
        this.$message.info('暂无预览地址')
      }
    },
    // 下载证书
    downloadCertificate(row) {
      if (row.cert_url) {
        const link = document.createElement('a')
        link.href = row.cert_url
        link.download = row.cert_name || 'certificate'
        link.click()
      } else {
        this.$message.info('暂无下载地址')
      }
    },
    addItem() {
      let item = {
        sku_name: '',
        sn: '',
        id: null,
        product_id: '',
        product_name: '',
        brandSort: null,
        type: null,
        unit_name: null,
        num: null,
        isEgdit: true,
        brand_name: '',
        brand_id: ''
      }
      this.list.push(item)
    },
    getDicList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        code: "InvoiceType"
      }
      this.$axios.dicListByPid(param).then(res => {
        if (res.code == 200) this.dicList = res.data
      }).catch(error => console.log(error))
    },
    getCateList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        code: "InvoiceCate"
      }
      this.$axios.dicListByPid(param).then(res => {
        if (res.code == 200) this.cateList = res.data
      }).catch(error => console.log(error))
    },
    getEmployeeList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.employeeList(param).then(res => {
        if (res.code == 200) this.employeeList = res.data
      }).catch(error => console.log(error))
    },
    getProvinceList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        parent_id: 1
      }
      this.$axios.regionList(param).then(res => {
        if (res.code == 200) this.provinceList = res.data
      }).catch(error => console.log(error))
    },
    getShopList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.shopList(param).then(res => {
        if (res.code == 200) {
          this.shopList = res.data
          if (res.data.length > 0) this.addForm.shop_id = res.data[0].id
        }
      }).catch(error => console.log(error))
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    submitForm() {
      this.$refs.formForRef.validate(valid => {
        if (valid) {
          let params = this.addForm
          this.$axios.constructionContractSave(params).then(res => {
            if (res.code == 200) {
              this.$message.success("保存成功")
              this.$router.push('/constructionContractList')
            }
          }).catch(error => {
            this.$message.error("保存错误")
            console.log(error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getOne() {
      let _this = this
      let param = {
        access_token: _this.access_token,
        company_id: _this.company_id,
        id: _this.addForm.id
      }
      this.$axios.shopOne(param).then(res => {
        if (res.code == 200) {
          _this.addForm = res.data
        }
        console.log(res)
      })
    },
    uploadFile(item) {
      let _this = this
      let file = item.raw
      this.logoFile = item.raw
      let param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      this.$axios.getAliJson(param).then(res => {
        let data = res['data']
        let suffix = _this.get_suffix(file.name)
        let autoname = _this.Ymdhis()
        let key = data['dir']
        let host = data['host']
        let request = new FormData()
        request.append('name', file.name)
        request.append("key", key + 'mrh/' + autoname + suffix)
        request.append("policy", data['policy'])
        request.append("OSSAccessKeyId", data['accessid'])
        request.append("success_action_status", '200')
        request.append("callback", data['callback'])
        request.append("Signature", data['signature'])
        request.append('file', file)
        axios.post('/alioss', request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          var fileurl = res.data.filename
          var fullurl = host + '/' + fileurl
          _this.ruleForm.ad_code = fullurl
          var img = { name: _this.ruleForm.ad_name, url: _this.ruleForm.fullurl }
          _this.fileList.push(img)
        }).catch(error => console.log(error))
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleBeforeUpload(file) {
      console.log(file)
    },
    uploadSuccess() {
    },
    handleIsopenSelect() {
    },
    getCateMenus() {
      let _this = this
      let url = '/api/api/mall.Ad_read_lz/getAdPositionMenus'
      let params = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      axios.post(url, params).then(res => {
        if (res.data.code == 200) _this.cateMenus = res.data.data
      })
      _this.submit = false
    },
    uploadImg(file, insertFn) {
      let _this = this
      let param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      this.$axios.getAliJson(param).then(res => {
        let data = res['data']
        let suffix = _this.get_suffix(file.name)
        let autoname = _this.Ymdhis()
        let key = data['dir']
        let host = data['host']
        let request = new FormData()
        request.append('name', file.name)
        request.append("key", key + 'mrh/' + autoname + suffix)
        request.append("policy", data['policy'])
        request.append("OSSAccessKeyId", data['accessid'])
        request.append("success_action_status", '200')
        request.append("callback", data['callback'])
        request.append("Signature", data['signature'])
        request.append('file', file)
        axios.post('/alioss', request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
          var fileurl = res.data.filename
          var fullurl = host + '/' + fileurl
          setTimeout(function () { insertFn(fullurl) }, 500)
        }).catch(error => console.log(error))
      })
    },
    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    get_suffix(filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos != -1) suffix = filename.substring(pos)
      return suffix
    },
    Ymdhis() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      return '' + year + month + day + hour + minute + second
    },
    urlParse(_url = '') {
      let url_obj = new URL(_url || window.location.href)
      let search_path = url_obj.search
      let handle_path = decodeURIComponent(search_path.substr(1))
      let handle_path_arr = handle_path.split('&')
      let search_params = {}
      for (let item of handle_path_arr) {
        let r = item.split('=')
        search_params[r[0]] = r[1]
      }
      return {
        protpcol: url_obj.protocol,
        search: url_obj.search,
        host: url_obj.host,
        port: url_obj.port,
        pathname: url_obj.pathname,
        searchParams: search_params
      }
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy()
  }
}
</script>

<style scoped>
/* 整体容器背景 */
.shop-info-container {
  background-color: #F5F7FA;
  min-height: 100vh;
  padding: 20px 24px 40px;
}

/* 面包屑美化 */
.custom-breadcrumb {
  margin-bottom: 20px;
}
.custom-breadcrumb >>> .el-breadcrumb__inner {
  color: #6C7A8E;
  font-weight: normal;
}
.custom-breadcrumb >>> .el-breadcrumb__inner a:hover {
  color: #1677FF;
}
.custom-breadcrumb >>> .el-breadcrumb__separator {
  color: #C0C4CC;
}

/* 主卡片 */
.modern-card {
  border-radius: 24px;
  border: none;
  background-color: #FFFFFF;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.01);
}
.modern-card >>> .el-card__body {
  padding: 28px 32px 32px;
}

/* 信息区块 */
.info-section {
  margin-bottom: 8px;
}
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1E2A3A;
  letter-spacing: 0.5px;
}
.section-line {
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, #E4E7ED, transparent);
  margin-left: 16px;
}

/* 描述列表 - 支付宝圆润风格 */
.alipay-descriptions {
  border-radius: 20px;
  overflow: hidden;
}
.alipay-descriptions >>> .el-descriptions__header {
  margin-bottom: 0;
}
.alipay-descriptions >>> .el-descriptions__body {
  background-color: #FFFFFF;
}
.alipay-descriptions >>> .el-descriptions__table {
  border-collapse: separate;
  border-spacing: 0;
}
.alipay-descriptions >>> .el-descriptions__table td,
.alipay-descriptions >>> .el-descriptions__table th {
  border: 1px solid #EDEFF2;
  padding: 14px 16px;
}
.alipay-descriptions >>> .desc-label {
  background-color: #F8F9FC;
  color: #5A6878;
  font-weight: 500;
  width: 140px;
}
.alipay-descriptions >>> .desc-content {
  color: #1E2A3A;
}
.alipay-descriptions >>> .el-tag--light {
  border-radius: 30px;
  background-color: #E8F7EF;
  color: #1AB86A;
  border: none;
}
.empty-placeholder {
  color: #A3AFC1;
  font-style: normal;
}

/* 表格支付宝风格 */
.alipay-table {
  border-radius: 20px;
  overflow: hidden;
}
.alipay-table >>> .el-table__header-wrapper th {
  background-color: #F8F9FC !important;
  font-weight: 600;
  color: #1E2A3A;
  border-bottom: 1px solid #EDEFF2;
}
.alipay-table >>> .el-table__row td {
  border-bottom: 1px solid #F0F2F5;
  padding: 12px 0;
}
.alipay-table >>> .el-table__row:hover td {
  background-color: #FAFBFF !important;
}
.alipay-table >>> .el-button--text {
  color: #1677FF;
  font-weight: 500;
}
.alipay-table >>> .el-button--text:hover {
  color: #0958D9;
}

/* 空状态自定义 */
.custom-empty {
  margin-top: 32px;
}
.custom-empty >>> .el-empty__description p {
  color: #8C9AA8;
  font-size: 14px;
}
</style>